import NamedDto from 'modules/base/dto/NamedDto';

export class worksheetModelOutputAttributeEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.worksheet = null;
		/** @type {string} */
		this.cell = null;
		/** @type {number} */
		this.orderIndex = null;
		/** @type {string} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _worksheetModelOutputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} uom
	 * @property {string} worksheet
	 * @property {string} cell
	 * @property {number} orderIndex
	 * @property {string} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _worksheetModelOutputAttributeEditDtoProps} worksheetModelOutputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {worksheetModelOutputAttributeEditDtoProps} props
	 * @returns {worksheetModelOutputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.uom = props.uom;
		this.worksheet = props.worksheet;
		this.cell = props.cell;
		this.orderIndex = props.orderIndex;
		this.value = props.value;

		return this;
	}
}

export default worksheetModelOutputAttributeEditDto;